module.exports = __webpack_public_path__ + "img/jelle_fogini_blazer.acdd48de.jpg";